// Not generated from samples: written from Appboy::Communication::Segment::AmperityCohortFilter
// (a PartnerCohortImportFilterBase, like the other partner cohort filters).

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const amperityCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("amperity_cohort_filter"),
  // Constants::Comparisons.discrete_items_comparisons
  comparison_key: z.enum(["7", "8"]),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on. The cohort id.
  raw_value: z.string().optional(),
  // value is the cohort name, or "[Deleted]" when the cohort no longer exists.
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
